// extracted by mini-css-extract-plugin
export default {"main":"Main_main__cFBYS"};